const backgroundRemover = {
  backgroundRemoverTitle: 'HitPaw Online AI Background Remover',
  NoWatermark: '透かしはありません',
  UnlimitedHDExport: '無制限のHDエクスポート',
  NoFileSizeLimit: 'ファイルサイズの制限はありません',
  BatchProcessing: '一括処理',
  UseAllTemplates: 'すべてのテンプレート、背景、要素、テキストが利用可能',
  CancelAtAnytime: 'いつでもキャンセルできます',
  HighPriorityUnlimited: '優先度の高い処理速度',
  YearDayPrice: '¥18',
  YearTotalPrice: '¥6,820',
  MonthDayPrice: '¥36',
  MonthTotalPrice: '¥1,100',
  WeekDayPrice: '¥78',
  WeekTotalPrice: '¥550',
  Day: '日',
  Monthly: '月',
  Weekly: '週',
  Yearly: '年',
};

export default backgroundRemover;
